import React, { useEffect, useRef, useState } from "react";
import { PrinterOutlined, ReloadOutlined, SaveOutlined } from "@ant-design/icons";
import SingleCheckBoxItem from "../profile/SingleCheckBokItem";
import { Flex, Radio } from "antd";
import { PRINTER_TYPES } from "../../constant/constants";
import UsbDeviceListCompoent from "./UsbDeviceListComponent";
import useUserStore from "../../stores/store";
import { getPrinterList, testPrinterConnection } from "../../services/print-sevice/print";

/**
 * This component should be used other places and everything should be done inside it or its child component but recommended not pass any data to its invoked page or component
 *
 * @param {*} isInvoice
 * @returns
 */
export default function PrinterSettingsOptions({
  isInvoice,
  isUseForAutoPrint,
  isServerDataLoaded,
  settingsData,
  onHandleSave,
  onChangeUseForPrinting,
}) {
  console.log("--PrinterSettingsOptions-----settingsData-----", settingsData);
  const { showNotification } = useUserStore();
  const [inputData, setInputData] = useState(settingsData);
  const [receivePrinterObj, setReceivePrinterObj] = useState({
    isLoadingPrinter: false,
    message: "",
    printerList: [],
    connectionType: "",
  });
  
  const displayPrinters = async () => {
    setReceivePrinterObj({ ...receivePrinterObj, isLoadingPrinter: true });

    const result = await getPrinterList();

    setReceivePrinterObj({ ...result, isLoadingPrinter: false });
  };

  const getDeviceInfo = (deviceInfo) => {
    console.log("---getUSBDeviceInfo--called--", { deviceInfo });

    setInputData((prev) => ({
      ...prev,
      printerName: deviceInfo,
    }));
  };

  const onChangeIsAutoCheckbox = (purpose, e) => {
    setInputData((prev) => ({
      ...prev,
      isAutoPrint: e.target.checked,
    }));
  };

  const handlePrinterTypeChange = (e) => {
    setInputData((prev) => ({
      ...prev,
      printerType: e.target.value,
    }));
  };
  
  const onHandleSavePrinterOptions = () => {
    onHandleSave(isInvoice, inputData);
  };

  const onHandleTestPrint = () => {
    testPrinterConnection(inputData, receivePrinterObj, showNotification);
  };

  useEffect(() => {
    if (isServerDataLoaded) {
      console.log("*********displayPrinters**called****");

      displayPrinters();
    }
  }, []);

  return (
    <div>
      <div className="mb-5">
        <SingleCheckBoxItem
          purpose={"KITCHEN_SLIP"}
          isChecked={inputData.isAutoPrint}
          mainLabel={""}
          checkboxLabel={"Auto Print"}
          onChangeHandler={onChangeIsAutoCheckbox}
        />
      </div>
      <div className="mb-5">
        <SingleCheckBoxItem
          purpose={isInvoice ? "INVOICE" :"KITCHEN_SLIP"}
          isChecked={isUseForAutoPrint}
          mainLabel={""}
          checkboxLabel={"Use this device for auto printing"}
          onChangeHandler={onChangeUseForPrinting}
        />
      </div>

      <div className="text-right">
        <button className=" bg-gray-200 px-5 py-2" onClick={displayPrinters}>
          <ReloadOutlined />
        </button>{" "}
      </div>

      <UsbDeviceListCompoent
        isInvoice={isInvoice}
        findPrinterData={receivePrinterObj}
        passDeviceInfo={getDeviceInfo}
        inputData={inputData}
      />
      

      <div className="font-semibold mb-1 mt-5">Printer Type</div>
      <div className="flex flex-row w-full ">
        <Flex vertical gap="middle">
          <Radio.Group
            block
            options={PRINTER_TYPES}
            defaultValue={inputData.printerType}
            style={{
              display: "flex",
              gap: 20,
            }}
            onChange={handlePrinterTypeChange}
          />
        </Flex>
      </div>
      <div className="w-[300px] flex m-auto justify-between pt-10 ">
        <button
          key="kitchenSlipOrInvoice"
          className="bg-[#2EC114] text-[#FFFFFF] rounded-[5px] font-semibold w-[110px]"
          onClick={() => onHandleSavePrinterOptions()}
          style={{
            padding: "8px 16px",
          }}
        >
          <SaveOutlined style={{ marginRight: 6 }} />
          Save
        </button>

        <button
          key="printOrDownload"
          onClick={() => onHandleTestPrint()}
          className="bg-yellow text-[#000000] rounded-[5px] font-semibold "
          style={{
            padding: "8px 16px",
          }}
        >
          <PrinterOutlined style={{ marginRight: 6 }} />
          Test Print
        </button>
      </div>
    </div>
  );
}
